import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const COLOR_TEXT = token('color.text', colors.N800);
const COLOR_TEXT_INVERSE = token('color.text.inverse', colors.N40);

export const cardColor = {
	default: {
		textColor: COLOR_TEXT,
		textColorSubtle: token('color.text.subtle', colors.N300),
		progressBar: {
			textColor: token('color.text.subtlest', colors.N200),
		},
		mouseLeave: {
			backgroundColor: token('elevation.surface.raised', colors.N0),
			textColor: COLOR_TEXT,
		},
		mouseOver: {
			backgroundColor: token('elevation.surface.raised.hovered', colors.N20),
			textColor: COLOR_TEXT,
		},
		mouseDown: {
			backgroundColor: token('color.background.neutral.subtle.pressed', '#DDDFE5'),
		},
	},
	active: {
		progressBar: {
			textColor: COLOR_TEXT_INVERSE,
		},
		mouseLeave: {
			backgroundColor: token('color.background.accent.blue.subtlest', '#E9F2FF'),
			textColor: COLOR_TEXT,
		},
		mouseOver: {
			backgroundColor: token('color.background.accent.blue.subtler', '#CCE0FF'),
			textColor: COLOR_TEXT,
		},
		mouseDown: {
			backgroundColor: token('color.background.selected.pressed', '#85B8FF'),
		},
	},
};
